import Lazy from 'jquery-lazy'

import {
    collapse
} from 'bootstrap'

import './mobileMenu'
import './eshop/app'
import './newsletter-popup'
import './sticky-menu'
import './top-drawer'
import './press'
import './marquee'

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, { passive: true });
    }
};

$('.lazy').Lazy({
    enableThrottle: false,
    threshold: 0,
    afterLoad: function (element) {
        element.find(".loader").fadeOut();
    },
});

$('.lazy-fade').Lazy({
    effect: "fadeIn",
    effectTime: 500,
    threshold: 0,
    afterLoad: function (element) {
        element.find(".loader").fadeOut();
    },
});

$("[data-bg-src]").each(function () {
    var imgUrl = $(this).data("bg-src");
    $(this).css({
        "background-image": "url(" + imgUrl + ")"
    });
})

$('.customer-care-collapse').on('show.bs.collapse', function () {
    $("html, body").animate({
        scrollTop: $('#customer-care').offset().top - 180
    }, "slow");
})

var urlParams = new URLSearchParams(window.location.search);
var accordionParam = urlParams.get('accordion')

if (accordionParam != null && accordionParam != "") {
    var accordion = "#" + accordionParam;
    $(accordion).collapse('show');
}